import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { formatToString } from 'utils/formatMoney'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import { CURRENCIES } from 'constants/app-config'

const MethodFee = ({ commission = {} }) => {
  const { t } = useTranslation(['billing'])
  const { value = null, currency } = commission

  if (value === null) {
    return null
  }

  return (
    <div className={styles['billing__calculated-data-item']}>
      {t('method_fee', {
        amount: formatToString(value, currency),
      })}
    </div>
  )
}

MethodFee.propTypes = {
  commission: PropTypes.shape({
    value: PropTypes.number,
    currency: PropTypes.oneOf(CURRENCIES),
  }),
}
export default MethodFee
